var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphonesOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.0588V17.8277C5 16.7557 5.86909 15.8866 6.94118 15.8866C8.01326 15.8866 8.88235 16.7557 8.88235 17.8277V21.0588C8.88235 22.1309 8.01326 23 6.94118 23C5.86909 23 5 22.1309 5 21.0588ZM5 19.4308V14.397C3.80578 15.0741 3 16.3568 3 17.8277V21.0588C3 23.2355 4.76452 25 6.94118 25C9.11783 25 10.8824 23.2355 10.8824 21.0588V17.8277C10.8824 15.6511 9.11783 13.8866 6.94118 13.8866C6.23542 13.8866 5.573 14.0721 5 14.397V14C5 9.02944 9.02944 5 14 5C18.9706 5 23 9.02944 23 14V14.397C22.427 14.0721 21.7646 13.8866 21.0588 13.8866C18.8822 13.8866 17.1176 15.6511 17.1176 17.8277V21.0588C17.1176 23.2355 18.8822 25 21.0588 25C23.2355 25 25 23.2355 25 21.0588V17.8277C25 16.3568 24.1942 15.0741 23 14.397V19.2971C23 19.8494 23.4477 20.2971 24 20.2971C24.5523 20.2971 25 19.8494 25 19.2971V14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14V19.4308C3 19.9831 3.44772 20.4308 4 20.4308C4.55228 20.4308 5 19.9831 5 19.4308ZM23 17.8277V21.0588C23 22.1309 22.1309 23 21.0588 23C19.9867 23 19.1176 22.1309 19.1176 21.0588V17.8277C19.1176 16.7557 19.9867 15.8866 21.0588 15.8866C22.1309 15.8866 23 16.7557 23 17.8277Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesOutline);
export default __webpack_public_path__ + "static/media/headphones_outline.7a64c5f4a3073d7b7eec79b7b6c87b8c.svg";
export { ForwardRef as ReactComponent };